module.exports = __webpack_public_path__ + "img/个人简历图标-1.6e4d66a9.png";